import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { useConversationAIStack } from '../../../../../pages/[lang]/webview/conversational-ai'
import WebviewStackContainer from '../../../common/WebviewStackContainer'

const AIRingleTipActivity = ({ params }) => {
  const { useConversationAIFlow } = useConversationAIStack()
  const { pop } = useConversationAIFlow()
  const { tag } = params
  const { t } = useTranslation()

  const arr = [1, 2, 3, 4, 5]

  return (
    <div>
      <WebviewStackContainer height="52px" onBack={pop} title={t(n_caf.highlight[`category${tag}`])} border={true}>
        <div className="h-screen overflow-auto bg-gray-50 px-20 pt-16">
          <div className="border-1 rounded-md border-gray-200 bg-white p-16">
            {arr.map((item) => {
              const isExist = !!t(n_caf.tip[`highlight${tag}`]) || !!t(n_caf.tip[`highlight${tag}`][`title${item}`])
              if (!isExist) return null
              return (
                <div key={item}>
                  <div className="text-16 mb-4 font-bold text-purple-500">
                    {t(n_caf.tip[`highlight${tag}`][`title${item}`])}
                  </div>
                  <div className="text-14 mb-32">{t(n_caf.tip[`highlight${tag}`][`body${item}`])}</div>
                </div>
              )
            })}
          </div>
        </div>
      </WebviewStackContainer>
    </div>
  )
}

export default AIRingleTipActivity
